import request from '@/utils/request'

export function getSchoolList(form, area, page) {
    return request({
        url: '/web/transfer_exam/getSchoolList',
        method: 'post',
        data: {
            scl_name: form.scl_name,
            page: page,
            limit: 20,
            area: area
        }
    })
}